<fa-icon *ngIf="getChartTypeIcon(type) as icon" [icon]="icon"></fa-icon>
